/* BaseActivityViewRender.js */

"use strict";
const Registrations = require("../../../RegistrationNamespaces");
const _ = require("lodash");

class BaseActivityViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("activity-view-gl");
        this._rootElem.component = this._model;
        this._defaultViewActive = false;
        this._activityGrid = {};
        this._gridRows = {};
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._activityGrid.on("UserSorted", (this._onGridUserSorted = this._onGridUserSorted.bind(this)));
        this._activityGrid.on("UserSelectedRows", (this._onGridUserSelectedRows = this._onGridUserSelectedRows.bind(this)));
        this._activityGrid.on("UserRowDoubleClicked", (this._onGridUserRowDoubleClicked = this._onGridUserRowDoubleClicked.bind(this)));
        this._activityGrid.on("GridAction", (this._onGridAction = this._onGridAction.bind(this)));
        //this._model.on('FeedInitialized', this._onFeedInitialized = this._onFeedInitialized.bind(this));
        this._model.on("ActivityAdded", (this._onActivityAdded = this._onActivityAdded.bind(this)));
        this._model.on("ActivityUpdated", (this._onActivityUpdated = this._onActivityUpdated.bind(this)));
        this._model.on("ActivityRemoved", (this._onActivityRemoved = this._onActivityRemoved.bind(this)));
    }

    _unregisterListeners() {
        if(this._activityGrid && !_.isEmpty(this._activityGrid)) {
            this._activityGrid.removeAllListeners("UserSorted");
            this._activityGrid.removeAllListeners("UserSelectedRows");
            this._activityGrid.removeAllListeners("UserRowDoubleClicked");
            this._activityGrid.removeAllListeners("GridAction");
        }
        //this._model.removeListener('FeedInitialized', this._onFeedInitialized);
        this._model.removeAllListeners("ActivityAdded", this._onActivityAdded);
        this._model.removeAllListeners("ActivityUpdated", this._onActivityUpdated);
        this._model.removeAllListeners("ActivityRemoved", this._onActivityRemoved);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        let promArr = [!_.isEmpty(this._activityGrid) ? this._activityGrid.shutdown() : Promise.resolve()];

        return Promise.all(promArr).then(
            () => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._defaultViewActive = undefined;
                this._activityGrid = undefined;
                this._gridRows = undefined;
            },
            (err) => {
                this.model._logger.warn({ error: err }, "ActivityViewRenderer.shutdown() error.");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (!this._rootElem.hasChildNodes()) {
            this._rootElem.appendChild(this._activityGrid.renderer.rootElement);
        }
        return this._model.whenModelIsReady().then(() => {
            this._registerListeners();
            this._hideDownloadViewAction();
            this._renderGridRows();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _renderGridRows() {
        this._gridRows = {};
        this._gridRows = this._model.getActivityList();
        // this._activityGrid.setRows(this._gridRows);
        if (Object.keys(this._gridRows).length === 0) {
            if (this._defaultViewActive === false) {
                this._showDefaultMessageDisplay();
            }
        } else {
            if (this._defaultViewActive === true) {
                this._hideDefaultMessageDisplay();
            }
        }
    }

    _showDownloadViewAction() {
        // this._model.gameEditor.showViewAction('download');
    }

    _hideDownloadViewAction() {
        // this._model.gameEditor.hideViewAction('download');
    }

    _showViewActions() {
        // this._model.gameEditor.showViewAction('download');
        // this._model.gameEditor.showViewAction('addNote');
    }

    _hideViewActions() {
        // this._model.gameEditor.hideViewAction('download');
        // this._model.gameEditor.hideViewAction('addNote');
    }

    _disableViewActions() {
        // this._model.gameEditor.disableViewAction('download');
        // this._model.gameEditor.disableViewAction('addNote');
    }

    _enableViewActions() {
        // this._model.gameEditor.enableViewAction('download');
        // this._model.gameEditor.enableViewAction('addNote');
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    //_onFeedInitialized() {
    //    this._renderGridRows();
    //}

    _onGridUserSorted(eventData) {
        this._model._onUserSorted(eventData);
    }

    _onActivityAdded(addedActivity) {
        this._activityGrid.addRow(addedActivity);
        if (this._defaultViewActive === true) {
            this._hideDefaultMessageDisplay();
        }
    }

    _onActivityRemoved(rowKey) {
        let removedRow = this._activityGrid.getRow(rowKey);
        this._activityGrid.deleteRow(removedRow);
        if (this._model.isActivityListEmpty() && this._defaultViewActive === false) {
            this._showDefaultMessageDisplay();
        }
    }

    _onActivityUpdated(updatedActivity) {
        this._activityGrid.updateRow(updatedActivity);
    }

    _onGridUserSelectedRows(selectedRowIds) {
        if (selectedRowIds && selectedRowIds.length === 1) {
            let selectedActivity = this._model.getActivityInListById(selectedRowIds[0]);
            if (selectedActivity) {
                switch (selectedActivity.getProperty("activityType")) {
                    case "create":
                    case "update":
                        this._showDownloadViewAction();
                        return;
                }
            }
        }
        this._hideDownloadViewAction();
    }

    _onGridUserRowDoubleClicked(row) {
        const activityEntity = this._model._activityFeed.getEntityById(row.selectedRow);
        const logId = _.get(activityEntity, 'jobId',
            _.get(activityEntity, 'workId',
                _.get(activityEntity, 'lastWorkId')));

        if (logId) {
            this._switchToLogView(logId);
        }
    }

    _onGridAction(actionData) {
        let action = actionData.eventData.action;
        // let rowId = actionData.rowId;
        switch (action) {
            case "viewMore":
                this._switchToLogView(_.get(actionData,['eventData','viewDetails', 'logId']));
                break;
            case "edit":
                // TODO: need to pass data
                this._switchToNoteView(actionData.rowId);
                break;
            case "delete":
                // TODO: need to pass data
                this._model.gameEditor.runConfirmationActionWorkflow(
                    {
                        message: "This will delete note blah blah",
                        title: "Delete Note",
                        confirmDetails: {
                            text: "Delete Note",
                            type: "destructive"
                        },
                        rejectDetails: {
                            text: "Cancel",
                            type: "text"
                        }
                    },
                    this._onDeleteConfirm,
                    {
                        message: "Delete Successful",
                        title: "Success"
                    }
                );
                break;
        }
    }

    _onDeleteConfirm() {
        return new Promise((resolve /*, reject*/) => {
            setTimeout(() => {
                resolve();
                //reject({
                //     errorCode: "BadError",
                //     errorMsg: "Something bad happened!",
                //     errorTitle: "OH NOES!"
                // })
            }, 2000);
        });
    }

    // _onAddNoteButtonClick(){
    //     // TODO: need to pass data
    //     console.info('ADD NOTE');
    //     this._switchToNoteView();
    //
    // }

    _onDownloadButtonClick() {
        let selectedRowIds = this._activityGrid.getSelectedRows();
        if (selectedRowIds && selectedRowIds.length === 1) {
            let selectedActivity = this._model.getActivityInListById(selectedRowIds[0]);
            this._model.downloadActivity(selectedActivity);
        }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _switchToNoteView() {
        this.model.gameEditor.setActiveView(Registrations.DIE_VIEW_NOTES, [
            {
                value: {
                    fqn: Registrations.DIE_VIEW_ACTIVITY
                },
                content: "Activity",
                left: {
                    arrow: {
                        direction: "left"
                    }
                }
            }
        ]);
    }

    _switchToJobView() {
        this.model.gameEditor.setActiveView(Registrations.DIE_VIEW_JOB, [
            {
                value: {
                    fqn: Registrations.DIE_VIEW_ACTIVITY
                },
                content: "Activity",
                left: {
                    arrow: {
                        direction: "left"
                    }
                }
            }
        ]);
    }

    _switchToLogView(rowId) {
        this.model.gameEditor.setActiveView(
            Registrations.DIE_VIEW_LOGS,
            [
                {
                    value: {
                        fqn: Registrations.DIE_VIEW_ACTIVITY
                    },
                    content: "Activity",
                    left: {
                        arrow: {
                            direction: "left"
                        }
                    }
                }
            ],
            {
                logId: rowId
            }
        );
    }

    _showDefaultMessageDisplay() {
        this._model.gameEditor
            .showDefaultMessageView({
                message: "No activities to display"
            })
            .then(() => {
                this._defaultViewActive = true;
            });
    }

    _hideDefaultMessageDisplay() {
        this._model.gameEditor.hideDefaultMessageView().then(() => {
            this._defaultViewActive = false;
        });
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = BaseActivityViewRenderer;
